import React from 'react';
// import KPTLImg from 'Icons/kptl-logo.png';
import LogoImg from 'Icons/Logo.jpg';
import Moment from 'moment';

const PRFormat = ({ trips, rfq, pdfRef }) => (
    <div className={'mt-10 mb-10 wt-95p box-shadow'} ref={pdfRef}>
        <div className={'col-1 ph-20 flex flex-middle'}>
            <div className={'wt-400 inBlock tCenter'}>
                <img src={LogoImg} alt="" width='300' className={'ml-10 mt-10'} height={'100'}/>
            </div>
            <div className={'wt-800 inBlock tCenter'}>
                {/* <div className={'fBold fs-16'}>{'KALPATARU POWER TRANSMISSION LTD.'}</div>
                <div className={'mt-5 fs-14'}>Immeuble Hajal Massad Centre, 3rd Floor</div>
                <div className={'mt-5 fs-14'}>Chambre 302 / 303, Carrefour Warda,</div>
                <div className={'mt-5 fs-14'}>Yaounde, Republic of Cameroon</div> */}
                 <div className={'fBold fs-16'}>{'ABC LTD.'}</div>
                <div className={'mt-5 fs-14'}>Bangalore, Karnataka, India</div>
            </div>
        </div>
        <div className="mt-20 ph-20">
            <table width="90%" cellPadding="0" cellSpacing="0">
                <tr>
                    <td><span className="fBold">Project No.: </span> {rfq.projectNumber || "-"}</td>
                    <td><span className="fBold">Site: </span>{rfq.site || "-"}</td>
                    <td><span className="fBold">Requisition No: </span>{rfq.requisitionNumber || "-"}</td>
                </tr>
                <tr>
                    <td><span className="fBold">Date: </span>{rfq.prDate && Moment(rfq.prDate).format('DD/MM/YYYY') || "-"}</td>
                    {/* <td><span className="fBold">Country: </span>{rfq.country || "-"}</td> */}
                    <td><span className="fBold">WBS: </span>{rfq.wbs || "-"}</td>
                </tr>
            </table>
        </div>

        {(trips || []).length > 0 && <div className="mt-20 ph-20 pr-table">
            <table  cellPadding="0" cellSpacing="0"  style={{'width': '80%'}}>
                <thead>
                <tr>
                    <th>Sr No.</th>
                    <th>Item Description</th>
                    <th>UOM</th>
                    <th>Total Estimated Qty</th>
                    <th>Quantity Prior to this PR</th>
                    <th>Quantity Proposed Now</th>
                    <th>Qty Balance to Procure</th>
                    <th style={{ 'borderRight': '1px solid grey'}}>Remarks</th>
                </tr>
                </thead>
                <tbody>
                {(trips || []).map((trip, tripIndex) => 
                (<tr key={tripIndex}>
                    <td>{tripIndex + 1}</td>
                    <td>{trip.material_code_description || 0}</td>
                    <td>{trip.uom || 0}</td>
                    <td>{trip.total_estimated_qty || 0}</td>
                    <td>{trip.qty_prior_to_pr || 0}</td>
                    <td>{trip.qty_proposed_now || 0}</td>
                    <td>{trip.qty_balance_to_procure || 0}</td>
                    <td style={{ 'borderRight': '1px solid grey'}}>{trip.remarks || ''}</td>
                </tr>))}
                </tbody>
            </table>
        </div>}
        <div className="mt-20 ph-20">
            <table cellPadding="0" cellSpacing="0">
                <tbody>
                    <tr><td style={{'padding': '2px'}}><span className="fBold">Activity:</span> {rfq.activity || "-"}</td></tr>
                    <tr><td style={{'padding': '2px'}}><span className="fBold">Approval Note No:</span> {rfq.approvalNoteNo || "-"}</td></tr>
                    <tr><td style={{'padding': '2px'}}><span className="fBold">Approved Budget:</span> {rfq.approvedBudget || "-"}</td></tr>
                    <tr><td style={{'padding': '2px'}}><span className="fBold">Consume Budget:</span> {rfq.consumeBudget || "-"}</td></tr>                   
                    <tr><td style={{'padding': '2px'}}><span className="fBold">Balance to Consume:</span> {rfq.balanceToConsume || "-"}</td></tr>
                </tbody>
            </table>
        </div>
    </div>
)

export default PRFormat;